import React, { Component } from 'react';

class Card2 extends Component {
    render() {
        let { 
            renderTitle,
            renderButton,
            renderForm,
            renderTable1,
            renderTable2,
        } = this.props;

        return <div className="nc-bill-extCard-2">
            <div className="nc-bill-header-area">
                <div className="header-title-search-area">
                    {renderTitle()}
                </div>
                <div className="header-button-area">
                    {renderButton()}
                </div>
            </div>
            <div className="nc-bill-top-area">
                <div className="nc-bill-form-area">
                    {renderForm()}
                </div>
            </div>
            <div className="nc-bill-table-area">
                {renderTable1()}
            </div>
            <div className="nc-bill-tableTab-area">
                {renderTable2()}
            </div>
        </div>;
    }
}

export default Card2;